import { useEffect } from 'react';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Outlet, useNavigate } from 'react-router-dom';

import { usePromoCodeContext } from 'contexts/PromoCodeContext';
import { STICKY_SHOP_NAVIGATION_STYLES } from 'hooks/useStickyShopNavigation';
import useTailwindTheme from 'hooks/useTailwindTheme';
import { trackExistingUserRedirect } from 'utils/analyticsUtils';
import { getSignupLocalStorage, removeSignupLocalStorage } from 'utils/signupUtils';

export default function AccountCreationLayout() {
    const { renderSignupNanoBanner } = usePromoCodeContext();
    const navigate = useNavigate();

    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });
    const onMembershipStep = window.location.pathname === '/join/membership';

    useEffect(() => {
        const storage = getSignupLocalStorage();

        const storageLooksLikeControlFlow = !!(
            storage?.dietaryPreference ||
            storage?.whoAreYouShoppingFor ||
            storage?.whatDoYouBuy ||
            storage?.percentOrganic
        );

        const storageLooksLikeDeprecatedFlow = !!(
            storage?.diet ||
            storage?.additionalPreferences ||
            typeof storage?.organicPreferences !== 'undefined' ||
            storage?.aisleSelection ||
            typeof storage?.householdSize !== 'undefined' ||
            typeof storage?.cookingFrequency !== 'undefined'
        );

        if (!storageLooksLikeControlFlow && !storageLooksLikeDeprecatedFlow) return;

        const storageIsNotValid = storageLooksLikeDeprecatedFlow && !storageLooksLikeControlFlow;

        if (storageIsNotValid) {
            trackExistingUserRedirect({ destination: '/join' });
            removeSignupLocalStorage();
            navigate('/join');
        }
    }, [navigate]);

    return (
        <>
            <main
                className={clsx('mx-auto flex max-w-(--breakpoint-md) flex-col px-25', {
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNanobanner]: renderSignupNanoBanner,
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNoNanobanner]: !renderSignupNanoBanner,
                    'py-0': onMembershipStep,
                    'py-25': !onMembershipStep,
                })}
            >
                <Outlet />
            </main>
            {!mobile && onMembershipStep && (
                <img
                    src="https://img-cdn.misfitsmarket.com/boysenberry/plusmembership/blueberries-desktop.png"
                    alt=""
                    className="fixed bottom-0 z-[-1] w-fit"
                />
            )}
        </>
    );
}
